import { Component, OnInit } from '@angular/core';
import {BookVersionIntegrationModel, BookVersionModel} from '../../../../models/edu-admin/book-version.model';
import {BookExamsService} from '../../../../services/student/book-exams.service';
import {UserModel} from '../../../../models/authentication/user.model';

@Component({
  selector: 'app-book-dashboard-container',
  templateUrl: './book-dashboard-container.component.html',
  styleUrls: ['./book-dashboard-container.component.css']
})
export class BookDashboardContainerComponent implements OnInit {

  bookVersions: BookVersionModel[] = [];
  currentBookVersion: BookVersionModel = null;

  constructor(private bookExamSv: BookExamsService) { }

  ngOnInit() {

    this.bookExamSv.fetchLatestBookVersionAndExamAttemptsGrouped().subscribe((bookVersion) => {

      if (bookVersion) {
        this.currentBookVersion = bookVersion;
      }

    });

  }

  currentBookProgress(): string {

    if (this.currentBookVersion) {

      const fraction = this.currentBookVersion.chaptersFinishedFraction() * 100;

      return fraction.toFixed(0);
    }

    return null;
  }

  hasCurrentBookProgress(): boolean {

    if (this.currentBookVersion && this.currentBookVersion.chaptersFinishedFraction() > 0) {

      return true;
    }

    return false;
  }

  integrationName(integration: BookVersionIntegrationModel): string {

    if (UserModel.getCurrent()) {

      return integration.monitorNames.stringForCulture(UserModel.getCurrent().culture);
    }

    return null;
  }

  integrationCorrectAnswers(integration: BookVersionIntegrationModel): number {

    if (integration.successfulAttempt) {

      return integration.successfulAttempt.numCorrect;
    } else if (integration.attempts.length > 0) {

      return integration.attempts[0].numCorrect;
    }

    return 0;

  }

  integrationExamNumAttempts(integration: BookVersionIntegrationModel) {

    return integration.attempts.length.toString(10);
  }

  integrationExamPassed(integration: BookVersionIntegrationModel): boolean {

    if (integration.successfulAttempt) {
      return true;
    }

    return false;
  }

}
